import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { ExtendedRewardProgram } from 'types';
import { AludelStatusForm } from './AludelStatusForm';
import { PowerSwitchStatus } from 'api/blockchain/rewardProgram';

type Props = {
  program: ExtendedRewardProgram;
  programState?: PowerSwitchStatus;
};

export const MaintenanceFormWrapper: FC<Props> = ({
  program,
  programState
}) => {
  return (
    <>
      <Box p={4}>
        <AludelStatusForm program={program} programState={programState} />
      </Box>
    </>
  );
};
